import { catchError, map } from 'rxjs/operators';
import { Injectable, Inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { APP_CONFIG, IAppConfig } from '../../app.config';
import { MessageService } from '../../core/service/message.service';
import { Observable } from 'rxjs';
import { NotificationBoard } from '../model/notification-board';

@Injectable()
export class NotificationBoardService {
  constructor(
    private _client: HttpClient,
    @Inject(APP_CONFIG) config: IAppConfig,
    private _messageService: MessageService
  ) {
    this._endpoint = `${config.apiEndpointV2}/notifications`;
  }

  private readonly _endpoint: string;

  get(): Observable<NotificationBoard> {
    return this._client.get(this._endpoint).pipe(
      map(x => Object.assign(new NotificationBoard(), x)),
      catchError(error => {
        this._messageService.showError(error);
        return [];
      })
    );
  }
}
